<template>
  <div class="flex items-center">
    <a href="#" @click.prevent="favorite()">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" :fill="isFavorited ? 'currentColor' : 'none'" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    </a>
    <span v-if="saved && unsaved" class="ml-2">
      {{ isFavorited ? saved : unsaved }}
    </span>
  </div>
</template>

<script>
  export default {
    name: 'Favorite',
    props: {
      url:{
        type: String,
        required: true
      },
      id:{
        type: Number,
        required: true
      },
      favorited: {
        type: Number,
        require: true,
        default: 0
      },
      saved:{
        type: String,
        required: false
      },
      unsaved:{
        type: String,
        required: false
      },
      reload: {
        type: Boolean,
        require: false,
        default: false
      }
    },
    data() {
      return {
        isFavorited: false
      }
    },
    mounted() {
      this.isFavorited = this.favorited ? true : false
    },
    methods: {
      favorite() {
        axios.post(this.url, {
          id: this.id
        })
        .then(response => {
          this.isFavorited = response.data.state
          if(this.reload) {
            window.location.reload()
          }
        })
        .catch(response => console.log(response.data))
      }
    }
  }
</script>
